export default __webpack_public_path__ + "static/media/explore3.2c8ad401.png";